export default "__VITE_ASSET__Dl4EgG0z__"